<input
  #fileInput
  type="file"
  accept=".xlsx"
  style="display: none"
  (change)="upload()"
  multiple
  />
<app-modal
  #discardSapModal
  [modalMessage]="app.text.internalItem.discard"
  [modalTitle]="app.text.thread.modalTitle"
  (ok)="clearItem()"
></app-modal>
<app-modal
  #deleteSapModal
  [modalMessage]="app.text.internalItem.deleteInternalItem"
  [modalTitle]="app.text.thread.modalTitle"
  (ok)="app.internalItems.deleteInternalItem()"
></app-modal>
<app-paginator
  [length]="app.internalItems.itemIds.length"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
></app-paginator>
<div class="$event.stopPropagation()">
  <div class="tableFixHead">
    <table class="table table-striped sap-data-table">
      <thead>
        <tr>
          @for (field of columns; track field) {
            <th class="p-1">
              {{ app.field.getLabel(field) }}
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (
          item of app.paginator.getPage(app.internalItems.items); track
          item; let i = $index) {
          <tr
            >
            @for (column of cleanColumns; track column) {
              <td class="p-1 text-center">
                <div>
                  @switch (app.table.getColumnTypeDisplay(column)) {
                    @case ('normal') {
                      <div class="min-width">
                        <input
                          type="text"
                          class="form-control"
                          [ngClass]="{ focus: focusInput }"
                          [(ngModel)]="item.part[column]"
                          [disabled]="!item.isEditable"
                          />
                      </div>
                    }
                    @case ('navigateAction') {
                      <div class="min-width">
                        <input
                          type="text"
                          class="form-control"
                          [ngClass]="{ focus: focusInput }"
                          [(ngModel)]="item.part[column]"
                          [disabled]="!item.isEditable"
                          />
                      </div>
                    }
                    @case ('checkBox') {
                      <div>
                        <input
                          class="form-check-input entryCheckBox"
                          type="checkbox"
                          [disabled]="!item.isEditable"
                          value=""
                          id="flexCheckDefault"
                          [(ngModel)]="item.part.entryCheckbox"
                          />
                      </div>
                    }
                    @case ('actions') {
                      <div>
                        <div
                          class="btn-group btn-group-sm actions-buttons"
                          role="group"
                          >
                          @if (!item.isEditable) {
                            <button
                              class="btn pe-1"
                              (click)="setEditable(item, index)"
                              >
                              <i
                                class="fa fa-edit"
                                (click)="setEditable(item, index)"
                              ></i>
                            </button>
                          }
                          @if (item.isEditable) {
                            <button
                              class="btn pe-1"
                              [disabled]="isDisabled(item)"
                              (click)="app.internalItems.save(item, index)"
                              >
                              <i class="fa fa-check"></i>
                            </button>
                          }
                          @if (item.isEditable) {
                            <button
                              class="btn pe-1"
                    (click)="
                      app.internalItems.currentItem = item;
                      discardSapModal.open()
                    "
                              >
                              <i class="fa fa-times"></i>
                            </button>
                          }
                          @if (!item.isEditable) {
                            <button
                              class="btn"
                    (click)="
                      app.internalItems.currentItem = item;
                      deleteSapModal.open()
                    "
                              >
                              <i class="fa fa-trash"></i>
                            </button>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
              </td>
            }
          </tr>
        }
        @if (app.internalItems.addNewSapDataItem) {
          <tr>
            @for (column of cleanColumns; track column) {
              <td class="p-1 text-center">
                <div>
                  @switch (app.table.getColumnTypeDisplay(column)) {
                    @case ('normal') {
                      <div>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="item.part[column]"
                          />
                      </div>
                    }
                    @case ('navigateAction') {
                      <div>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="item.part[column]"
                          />
                      </div>
                    }
                    @case ('checkBox') {
                      <div>
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                          [(ngModel)]="item.part.entryCheckbox"
                          />
                      </div>
                    }
                    @case ('actions') {
                      <div>
                        <div class="btn-group btn-group-sm action-buttons" role="group">
                          @if (app.permission.impact.canAddImpactToCase) {
                            <button
                              type="button"
                              class="btn pe-1"
                              [disabled]="!item.part.partNumber"
                              (click)="app.internalItems.save(item)"
                              >
                              <i class="fa fa-check"></i>
                            </button>
                          }
                          <button
                            type="button"
                            class="btn pe-1"
                            [disabled]="!item.part.partNumber"
                    (click)="
                      app.internalItems.currentItem = item;
                      discardSapModal.open()
                    "
                            >
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                    }
                  }
                </div>
              </td>
            }
          </tr>
        }
        <tr>
          @if (app.internalItems.itemExists) {
            <td
              colspan="99"
              class="text-center"
              >
              <div class="error-notification" style="cursor: pointer">
                <div class="p-1">
                  <i class="fas fa-exclamation-triangle"></i>
                  {{ app.text.internalItem.itemExists }}
                  <div
                    class="close-btn pull-right"
                    (click)="app.hasError = false"
                    >
                    <i class="fa fa-times"></i>
                  </div>
                </div>
              </div>
            </td>
          }
          @if (app.internalItems.hasSuccess) {
            <td
              colspan="99"
              class="text-center"
              >
              <div class="success success-notification" style="cursor: pointer">
                <div class="p-1">
                  <i class="fa fa-check"></i>
                  {{ this.app.text.internalItem.itemSavedSuccesfully }}
                  <div
                    class="close-btn pull-right"
                    (click)="app.hasSuccess = false"
                    >
                    <i class="fa fa-times"></i>
                  </div>
                </div>
              </div>
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-paginator
  [length]="app.internalItems.itemIds.length"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
></app-paginator>
<div class="bottom-buttons">
  @if (app.permission.impact.canAddImpactToCase) {
    <button
      class="btn"
      (click)="fileInput.click()"
      [title]="app.text.import.upload"
      >
      <i class="fa fa-upload"></i>
    </button>
  }
  @if (app.permission.impact.canAddImpactToCase) {
    <button
      class="btn btn-light pull-right"
      (click)="deleteItem(); app.internalItems.addNewItem()"
      >
      New
    </button>
  }
</div>
